import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.userListing || initialState;

export const selectSummaryData = createSelector(
  [selectDomain],
  (state) => state.summaryData
);

export const selectCompanyCount = createSelector(
  [selectDomain],
  (state) => state.companyCount
);

export const selectTotalCompanies = createSelector(
  [selectDomain],
  (state) => state.totalCompanies
);
